import type { FC } from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import TierManageContentButton from '@wix/da-shared-react/pkg/Tier/TierManageContentButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TiersDropdown from '../TiersDropdown';
import TierActions from '../TierActions';
import {
  getProfileOwner,
  isCurrentUserProfileOwner,
} from '../../../../../../selectors/users';
import { getSelectedOrFirstTier } from '../../../../../../selectors/subscriptionsSection';
import s from './TierContentToolbar.scss';

export interface Props {
  className?: string;
}

const TierContentToolbar: FC<Props> = ({ className }) => {
  const isMobile = useContext(MobileContext);
  const profileOwner = useSelector(getProfileOwner);
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const tier = useSelector(getSelectedOrFirstTier);

  if (!tier) {
    return null;
  }

  const renderManageContentButtons = () => (
    <>
      <TierManageContentButton
        type={'deviations'}
        tierDeviation={tier}
        profileOwner={profileOwner.user}
        className={s['manage-content-button']}
      />
      <TierManageContentButton
        type={'posts'}
        tierDeviation={tier}
        profileOwner={profileOwner.user}
        className={s['manage-content-button']}
      />
    </>
  );

  const renderRightSideControls = () => {
    if (!isMobile && isOwner && tier.isPublished) {
      return renderManageContentButtons();
    }
    if (!isOwner) {
      return <TierActions deviation={tier} />;
    }
  };

  const rightSide = renderRightSideControls();

  return (
    <div className={`${s['toolbar']} ${className || ''}`}>
      {!isMobile && <TiersDropdown className={s['title']} />}
      <div className={s['spacer']} />
      <div className={s['right-side-area']}>{rightSide}</div>
    </div>
  );
};

TierContentToolbar.displayName = 'TierContentToolbar';

export default TierContentToolbar;
